"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  var className = props.className,
      _props$type = props.type,
      type = _props$type === void 0 ? 'radio' : _props$type,
      disabled = props.disabled,
      name = props.name,
      label = props.label,
      options = props.options;
  var fieldProps = {
    type: type,
    name: name,
    disabled: disabled
  };
  var classes = ["radio-group-".concat(name), 'curb-radio-group', 'curb-form-element'];

  if (className) {
    classes.push(className);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' ')
  }, label && /*#__PURE__*/_react.default.createElement("label", null, label), /*#__PURE__*/_react.default.createElement("div", {
    className: "options-wrapper"
  }, options.map(function (_ref, index) {
    var label = _ref.label,
        value = _ref.value;
    var key = "".concat(name, "[").concat(index, "]");
    var classes = ['curb-radio', 'curb-group-item', "curb-radio-item-".concat(name, "-").concat(value)];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.join(' '),
      key: key
    }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, _extends({
      component: "input"
    }, fieldProps, {
      value: value
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "label-content"
    }, label)));
  })));
}